import { getItem, setItem } from "Common/localStorage/utils";
import Resizable from "Components/resizable";
import RotatedArrow from "Components/rotatedArrow";
import SlideUpDown from "Components/slideUpDown";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import isNil from "lodash/isNil";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { localStorageSettingsKey } from "./constants";
import InnerPanel from "./innerPanel";
import locale from "./rightSideDetailsPanel.locale";
const SIZES = {
    DEFAULT_PANEL_WIDTH: 380,
    MIN_PANEL_WIDTH: 380,
    MAX_PANEL_WIDTH: 800
};
const handlePreventDefault = (e) => {
    e.preventDefault();
};
export default function RightSideDetailsPanel(props) {
    var _a;
    const collapsedButtonRef = useRef(null);
    const [settings, setSettings] = useState(() => {
        const localStorageData = getItem(localStorageSettingsKey);
        return {
            width: Number.parseInt(localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.width) || SIZES.DEFAULT_PANEL_WIDTH
        };
    });
    useEffect(() => {
        var _a, _b;
        if (props.autoOpenByDataLength && props.onChangeOpen) {
            ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) === 1 && props.onChangeOpen(true);
            (!props.data || ((_b = props.data) === null || _b === void 0 ? void 0 : _b.length) === 0) && props.onChangeOpen(undefined);
        }
    }, [(_a = props.data) === null || _a === void 0 ? void 0 : _a.length, props.onChangeOpen, props.autoOpenByDataLength]);
    useEffect(() => () => {
        props.onChangeOpen && props.onChangeOpen(undefined);
    }, [props.documentId]);
    useEffect(() => {
        if (collapsedButtonRef.current) {
            collapsedButtonRef.current.style.width = `${settings.width}px`;
        }
        setItem(localStorageSettingsKey, settings);
        props.onSetPanelWidth && props.onSetPanelWidth(settings.width);
    }, [settings]);
    const handleResize = useCallback((e) => {
        if (collapsedButtonRef.current) {
            collapsedButtonRef.current.style.width = `${e.width}px`;
        }
        props.onSetPanelWidth && props.onSetPanelWidth(e.width);
    }, []);
    const handleResizeEnd = useCallback((e) => {
        setSettings({ width: e.width });
    }, []);
    const handleToggleDetailedPanelOpen = useCallback(() => {
        props.onChangeOpen && props.onChangeOpen(!props.open);
    }, [props.open, props.onChangeOpen]);
    const collapsedButtonStyle = useMemo(() => ({ height: props.closedHeight }), [props.closedHeight]);
    const slideUpDownStyle = useMemo(() => ({
        position: "absolute",
        top: props.closedHeight,
        right: 0,
        zIndex: themeVariables["zindex-devextreme-dx-menu-base"]
    }), [props.closedHeight]);
    return !isNil(props.documentId) ? (React.createElement("div", { className: "position-relative p-0", onContextMenu: handlePreventDefault },
        React.createElement("div", { style: collapsedButtonStyle, ref: collapsedButtonRef, className: "grid-cols-1fr-auto border-left-gray-100 clickable pl-1 pr-1", onClick: handleToggleDetailedPanelOpen },
            React.createElement("div", { className: "d-grid align-content-center" }, locale.PROPERTIES),
            React.createElement(RotatedArrow, { className: "flex-box-centered-content text-light-on-surface-variant", open: props.open, size: 16 })),
        React.createElement(SlideUpDown, { className: "bg-white w-100 w-100-max overflow-hidden", open: Boolean(props.open), style: slideUpDownStyle, openedHeight: props.openedHeight, unmountOnExit: true },
            React.createElement(Resizable, { className: classNames(props.className, "stretched-to-fit custom-left-resizable"), minWidth: SIZES.MIN_PANEL_WIDTH, maxWidth: SIZES.MAX_PANEL_WIDTH, defaultWidth: settings.width, onResize: handleResize, onResizeEnd: handleResizeEnd, handles: "left" },
                React.createElement(InnerPanel, { key: props.documentId, documentId: props.documentId, data: props.data, onDataUpdate: props.onDataUpdate, documentObjects: props.documentObjects, height: props.openedHeight, tableColumns: props.tableColumns, canModifyAttributes: props.canModifyAttributes, zIndex: parseInt(themeVariables["zindex-devextreme-dx-menu-base"]), onRowsPin: props.onRowsPin, onGetPreview: props.onGetPreview, onOpenGroupTableViewModal: props.onOpenGroupTableViewModal }))))) : null;
}
RightSideDetailsPanel.defaultProps = {
    autoOpenByDataLength: true
};
